// @flow
import React from 'react';
import styled from 'styled-components';
import {FlexColumn} from 'styles/Layout';

const Container = styled(FlexColumn)`
  justify-content: center;
  height: ${props => props.size}px;
  width: ${props => props.size}px;
  border: 4px solid ${props => props.color};
  background-color: #ffffff;
  border-radius: 50%;
`;
const Score = styled.span`
  color: #4a4a4a;
  font-size: ${props => props.fontSize}px;
  font-weight: bold;
  text-align: center;
`;
type PropsType = {
  color?: string,
  score: number,
  fontSize: number,
  size: number
};

export default function ScoreFunction(props: PropsType) {
  const { score = 0, fontSize = 30, size = 110, color = '#48c16a' } = props;
  return (
    <Container color={color} size={size}>
      <Score fontSize={fontSize}>{score}</Score>
    </Container>
  );
}
